module.exports = __webpack_public_path__ + "img/album16_08.7a7de32c.jpg";